// Copyright (c) 2022, 37.78 Tecnologia Ltda. All rights reserved.

import { useContext } from "react";

import { MixpanelContext } from "./MixpanelContext";

export const useMixpanel = () => useContext(MixpanelContext);
